// extracted by mini-css-extract-plugin
export default {"products":"cw-z","card":"dw-z","oosMessaging":"ew-z"};